import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import OpsStatusDot from './ops-status-dot';
import type { ProcessorOpsHealthStatus } from '@/types/dtos/ops/ops-platform.dto';

type OpsDomainPanelProps = {
  title: string;
  icon: ReactNode;
  health: ProcessorOpsHealthStatus | null | undefined;
  headline?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export default function OpsDomainPanel({ title, icon, health, headline, children, footer }: OpsDomainPanelProps) {
  return (
    <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ 'py': 1.25, 'px': 1.5, 'flex': 1, '&:last-child': { pb: 1.25 } }}>
        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 1 }}>
          {icon}
          <Typography variant="subtitle2" sx={{ flex: 1, lineHeight: 1.2 }}>
            {title}
          </Typography>
          <OpsStatusDot status={health} />
        </Stack>
        {headline && (
          <Typography
            variant="caption"
            color={health === 'critical' ? 'error.main' : 'warning.main'}
            sx={{ display: 'block', mb: 0.75 }}
          >
            {headline}
          </Typography>
        )}
        <Stack spacing={0.75}>{children}</Stack>
        {footer && <Box sx={{ mt: 0.75 }}>{footer}</Box>}
      </CardContent>
    </Card>
  );
}
